import { TinyColor } from '@ctrl/tinycolor';
import { css, type Theme } from '@emotion/react';

export const migratedAlert = (theme: Theme) => css`
  max-width: 761px;
  border-radius: 8px;

  box-shadow:
    0px 1px 2px 0px
      ${new TinyColor(theme.colors.gray[900]).setAlpha(0.1).toRgbString()},
    0px 0px 5px 1px
      ${new TinyColor(theme.colors.gray[900]).setAlpha(0.1).toRgbString()};
`;

export const migratedAlertContent = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (min-width: ${theme.breakpoints.large}) {
    flex-direction: row;
    justify-content: space-between;

    align-items: center;
  }
`;

export const migratedAlertButton = css`
  white-space: nowrap;
`;
